import { faChartPie } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';

export const ReportIcon = (props: { color?: string }) => {
  return (
    <FontAwesomeIcon icon={faChartPie} color={props.color || 'black'} />
  )
}
